import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-hero',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './hero.component.html',
  styleUrl: './hero.component.css'
})
export class HeroComponent {
  @Input() brandLogoSrc = '';
  @Input() brandLogoAlt = 'United Team Building logo';
  @Input() eyebrow = '';
  @Input() title = '';
  @Input() subtitle = '';
  @Input() primaryCtaLabel = '';
  @Input() primaryCtaLink = '/';
  @Input() primaryCtaFragment = '';
  @Input() secondaryCtaLabel = '';
  @Input() secondaryCtaLink = '/';
  @Input() secondaryCtaFragment = '';
}
